import axiosInstance from "core/api/axiosInstance";

// Obtener TODAS las propiedades (sin filtrar por commerceId)
export const getPropiedadesService = async () => {
  try {
    const { data } = await axiosInstance.get("/api/automatization/cbrs/co_prop/commerce");

    if (!data || typeof data !== "object") {
      return {
        success: false,
        error: "Respuesta inválida del servidor",
        data: [],
        total: 0,
        activeCount: 0,
        inactiveCount: 0,
      };
    }

    const recordsArray = Array.isArray(data.data) ? data.data : [];

    const processedData = recordsArray.map((propiedad) => ({
      id: propiedad.id,
      name: propiedad.name || "",
      ip: propiedad.ip || "",
      description: propiedad.description || "",
      status: propiedad.status ?? 0,
      idcopropietarie: propiedad.ref_table?.idcopropietarie || "",
      user_create: propiedad.user_create || "",
      config: propiedad.config || null,
      createdAt: propiedad.createdAt || "",
      updatedAt: propiedad.updatedAt || "",
    }));

    const activeCount = processedData.filter((p) => p.status === 1).length;
    const inactiveCount = processedData.filter((p) => p.status === 0).length;

    return {
      success: true,
      data: processedData,
      total: processedData.length,
      activeCount: activeCount,
      inactiveCount: inactiveCount,
      message: data.msm || "Propiedades obtenidas exitosamente",
    };
  } catch (error) {
    console.error("❌ Error al obtener propiedades:", error);
    return {
      success: false,
      error: error.message || "Error al obtener propiedades",
      data: [],
      total: 0,
      activeCount: 0,
      inactiveCount: 0,
    };
  }
};

// Crear una nueva propiedad
export const createPropiedadService = async (propiedadData) => {
  try {
    const payload = {
      name: propiedadData.name,
      ip: propiedadData.ip,
      description: propiedadData.description || "",
      idcopropietarie: Number(propiedadData.idcopropietarie),
    };

    const { data } = await axiosInstance.post(
      "/api/automatization/cbrs/co_prop/commerce-create",
      payload
    );

    if (data && data.msm === "succesful") {
      const newPropiedad = {
        id: data.data?.id || Date.now(),
        name: payload.name,
        ip: payload.ip,
        description: payload.description,
        idcopropietarie: payload.idcopropietarie,
        user_create: propiedadData.user_create || "",
        status: 1,
        config: null,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      };

      return {
        success: true,
        data: newPropiedad,
        message: "Propiedad creada exitosamente",
      };
    } else {
      const errorMsg =
        data?.message || data?.data?.error || data?.msm || "Error al crear la propiedad";
      console.error("❌ Error del servidor:", errorMsg);
      return {
        success: false,
        error: errorMsg,
      };
    }
  } catch (error) {
    console.error("❌ Error al crear propiedad:", error);
    const errorMsg =
      error.response?.data?.message ||
      error.response?.data?.data?.error ||
      error.message ||
      "Error al crear la propiedad";
    return {
      success: false,
      error: errorMsg,
    };
  }
};

// Actualizar una propiedad existente
export const updatePropiedadService = async (propiedadData) => {
  try {
    const payload = {
      id: Number(propiedadData.id),
      name: propiedadData.name,
      ip: propiedadData.ip || "",
      description: propiedadData.description || "",
      config: propiedadData.config || "", // Agregamos config como campo opcional
    };

    const { data } = await axiosInstance.put(
      "/api/automatization/cbrs/co_prop/commerce-update",
      payload
    );

    if (data && data.msm === "succesful") {
      return {
        success: true,
        data: propiedadData,
        message: "Propiedad actualizada exitosamente",
      };
    } else {
      const errorMsg =
        data?.message || data?.data?.error || data?.msm || "Error al actualizar la propiedad";
      console.error("❌ Error del servidor:", errorMsg);
      return {
        success: false,
        error: errorMsg,
      };
    }
  } catch (error) {
    console.error("❌ Error al actualizar propiedad:", error);
    const errorMsg =
      error.response?.data?.message ||
      error.response?.data?.data?.error ||
      error.message ||
      "Error al actualizar la propiedad";
    return {
      success: false,
      error: errorMsg,
    };
  }
};

// Cambiar el estado de una propiedad (Activar/Inactivar)
export const updatePropiedadStatusService = async (id, status) => {
  try {
    const payload = {
      id_commerce: Number(id),
      status: Number(status), // 1: Activo, 0: Inactivo
    };

    const { data } = await axiosInstance.put(
      "/api/automatization/cbrs/co_prop/commerce-status",
      payload
    );

    if (data && data.msm === "succesful") {
      return {
        success: true,
        message:
          status === 1 ? "Propiedad activada exitosamente" : "Propiedad desactivada exitosamente",
        data: data.data,
      };
    } else {
      const errorMsg =
        data?.message ||
        data?.data?.error ||
        data?.msm ||
        "Error al cambiar el estado de la propiedad";
      console.error("❌ Error del servidor:", errorMsg);
      return {
        success: false,
        error: errorMsg,
      };
    }
  } catch (error) {
    console.error("❌ Error al cambiar estado de propiedad:", error);
    const errorMsg =
      error.response?.data?.message ||
      error.response?.data?.data?.error ||
      error.message ||
      "Error al cambiar el estado de la propiedad";
    return {
      success: false,
      error: errorMsg,
    };
  }
};
